import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import CustomerService from "../../../Customer/Controller/CustomerController";
import MultipleEmail from "../../../Common/MultipleEmail";
import Swal from 'sweetalert2';

function LeadEmailingList({ show, onClose,EmailingName }) {
    const { theme } = useContext(ThemeContext);
    const [customerList, setCustomerData] = useState([]);
    const [customerEmailName, setCustomerEmailName] = useState([]);
    const [selectedEmailName, setSelectedEmailName] = useState(""); // 🔹 new state for dropdown
    const [multipleEmails, setMultipleEmails] = useState([]);
    const [LeadIDForEmail, setLeadIDForEmail] = useState();
    const [multipleIds, setMultipleIds] = useState([]);
    const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
    const [lastCheckedIndex, setLastCheckedIndex] = useState(null);

    const tableRef = useRef();
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            console.log('Destroying existing DataTable instance...');
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {
                console.log('DataTable initialization complete.');
                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    useEffect(() => {
        if (customerList && customerList.length > 0) {
            initDataTable();
        }
    }, [customerList]);

    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    const handleStart = (e, ui) => e.stopPropagation();

    // ---------------------- FETCH FUNCTIONS ----------------------
    useEffect(() => {
        fetchCustomerEmailing(EmailingName);// populate dropdown
    }, []);

    async function fetchCustomerEmailing(emailName) {
        try {
            // 🔹 Updated: pass selected emailName to backend (if provided)
            const CustomerList = await CustomerService.GetEmailing("18", emailName);
            setCustomerData(CustomerList);
        } catch (error) {
            console.error('Error fetching customer emailing list:', error);
        }
    }

    async function fetchEmailingName() {
        try {
            const emailNameList = await CustomerService.GetEmailingByName("18");
            setCustomerEmailName(emailNameList);
        } catch (error) {
            console.error('Error fetching emailing names:', error);
        }
    }

    // 🔹 When dropdown value changes, fetch related customers
 /*   const handleEmailNameChange = async (e) => {
        $(tableRef.current).DataTable().destroy();
        const selectedValue = e.target.value;
        setSelectedEmailName(selectedValue);
        if (selectedValue) {
            await fetchCustomerEmailing(selectedValue);
        } else {
            setCustomerData([]); // clear if none selected
        }
    };*/

    const handleCloseEmailModal = async () => {
        await fetchCustomerEmailing(EmailingName);
        setIsMultipleEmailModalOpen(false);
        onClose();
    };

    // ---------------------- CHECKBOX LOGIC ----------------------
    const handleCheckboxClick = (event, id, index) => {
        event.stopPropagation();
        const isChecked = event.target.checked;

        if (event.shiftKey && lastCheckedIndex !== null) {
            const start = Math.min(lastCheckedIndex, index);
            const end = Math.max(lastCheckedIndex, index);
            const idsInRange = customerList.slice(start, end + 1).map(l => l.ID);

            setMultipleIds(prev => {
                const s = new Set(prev);
                if (isChecked) idsInRange.forEach(x => s.add(x));
                else idsInRange.forEach(x => s.delete(x));
                return Array.from(s);
            });
        } else {
            setMultipleIds(prev => {
                const s = new Set(prev);
                if (isChecked) s.add(id); else s.delete(id);
                return Array.from(s);
            });
        }
        setLastCheckedIndex(index);
    };

    // ---------------------- SEND EMAIL ----------------------
    const handleSendMultipleEmail = async () => {
        if (multipleIds.length > 0) {
            const emails = multipleIds
                .map(id => {
                    const contact = customerList.find(c => c.ID === id);
                    return contact ? contact.vc_Email : '';
                })
                .filter(email => email);
            setMultipleEmails(emails);
            setIsMultipleEmailModalOpen(true);
        } else {
            Swal.fire('Error!', 'Please select at least one record to send email.', 'error');
        }
    };
    const handleDeleteClick = async (ID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to delete`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: "Confirm"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    $(tableRef.current).DataTable().destroy();
                    await CustomerService.DeleteEmailingByID(ID);
                    await fetchCustomerEmailing(EmailingName);
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });

    };

    // ---------------------- RENDER ----------------------
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog modal-lg emailingList">
                <Draggable
                    handle=".modal-header"
                    onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Emailing List</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            {/* 🔹 Dropdown Above Table */}
                            

                            {/* Table */}
                            <div style={{ marginLeft: "10px", marginRight: "0px", marginTop: "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th className="no-wrap">Company Name</th>
                                            <th className="no-wrap">Product/Service Interest</th>
                                            <th className="no-wrap">Weight</th>
                                            <th className="no-wrap">Contact Name</th>
                                            <th className="no-wrap">Email</th>
                                            <th className="no-wrap">Status</th>
                                            <th className="no-wrap">Source</th>
                                            <th className="no-wrap"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customerList.map((customer, index) => (
                                            <tr key={customer.ID} style={{ cursor: 'pointer' }}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={multipleIds.includes(customer.ID)}
                                                        onClick={(event) =>
                                                            handleCheckboxClick(event, customer.ID, index)
                                                        }
                                                    />
                                                </td>
                                                <td className="no-wrap">{truncateText(customer.vc_Company)}</td>
                                                <td className="no-wrap">{truncateText(customer.vc_Topic)}</td>
                                                 <td className="no-wrap">{truncateText(customer.dec_Weight)}</td>
                                                <td className="no-wrap">
                                                   {truncateText(customer.vc_Title)} {truncateText(customer.vc_FirstName)} {truncateText(customer.vc_Surname)}
                                                </td>
                                                <td className="no-wrap">{truncateText(customer.vc_Email)}</td>
                                                <td className="no-wrap">{truncateText(customer.StatusName)}</td>
                                                
                                                <td className="no-wrap">{truncateText(customer.SourceName)}</td>
                                                <td style={{ "textAlign": "right" }}>

                                                    <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteClick(customer.EmailingID)}>
                                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-primary" onClick={handleSendMultipleEmail}>
                                <i className="icofont-save" aria-hidden="true"></i> Send
                            </button>
                            <button className="btn btn-secondary" type="button" onClick={onClose}>
                                <i className="icofont-close" aria-hidden="true"></i> Close
                            </button>
                        </div>
                    </div>
                </Draggable>
            </div>

            {/* Multiple Email Modal */}
            {isMultipleEmailModalOpen && (
                <MultipleEmail
                    onClose={handleCloseEmailModal}
                    ToEmail={multipleEmails}
                    Module="Customer"
                    ModuleID={LeadIDForEmail}
                    MultipleIDs={multipleIds}
                />
            )}
        </div>
    );
}

export default LeadEmailingList;
